import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  TaskNameSchema,
  TaskOrderingSchema,
  TasksResponseSchema,
  TaskStatusSchema,
  type TaskItemSchema,
} from '../shared/schemas/tasks.js';

export const checkPendingTasks = defaultClient.query({
  url: `omni-trafficking/v1/tasks/` as const,
  method: 'GET',
  responseSchema: TasksResponseSchema,
  querySchema: z.object({
    settingsId: z.string(),
    status: TaskStatusSchema.default(TaskStatusSchema.enum.pending),
    name: z.array(TaskNameSchema).optional(),
    ordering: TaskOrderingSchema.optional(),
    limit: z.number().int().positive().optional(),
  }),
  snakeCaseQueryParams: true,
});

export type TaskItemType = z.infer<typeof TaskItemSchema>;
export type TasksResponseType = z.infer<typeof TasksResponseSchema>;

export { TaskItemSchema } from '../shared/schemas/tasks.js';
export const TaskNameEnum = TaskNameSchema.enum;
export const TaskOrderingEnum = TaskOrderingSchema.enum;
export const TaskStatusEnum = TaskStatusSchema.enum;
